const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            const elements = document.querySelectorAll('.camouflage-marked-unavailable')
            elements.forEach((element) => {
                element.remove()
            })
        }
    })
})

observer.observe(document.body, {
    childList: true,
    subtree: true
})
